module.exports = __webpack_public_path__ + "img/littletitle_bg02.96f83870.png";